"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.glyphs = exports.glyphNames = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _standardGlyphs = require("./standardGlyphs");
var _hackclubGlyphs = require("./hackclubGlyphs");
var _excluded = ["is", "size", "glyph"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var mergedGlyphs = _objectSpread(_objectSpread({}, _standardGlyphs.standardGlyphs), _hackclubGlyphs.hackclubGlyphs);

// keep long-standing glyph names for compatibility
var hasLeaders = Object.prototype.hasOwnProperty.call(mergedGlyphs, "leaders");
var hasLeaderCircle = Object.prototype.hasOwnProperty.call(mergedGlyphs, "leader-circle");
var legacyGlyphs = hasLeaders || !hasLeaderCircle ? {} : {
  leaders: mergedGlyphs["leader-circle"]
};
var glyphs = exports.glyphs = _objectSpread(_objectSpread({}, mergedGlyphs), legacyGlyphs);
var glyphNames = exports.glyphNames = Object.keys(glyphs);
function Icon(_ref) {
  var is = _ref.is,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$glyph = _ref.glyph,
    glyph = _ref$glyph === void 0 ? "like" : _ref$glyph,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = is !== null && is !== void 0 ? is : "svg";
  return /*#__PURE__*/_react["default"].createElement(Component, _objectSpread({
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: "1.414",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": glyph,
    viewBox: "0 0 32 32",
    preserveAspectRatio: "xMidYMid meet",
    fill: "currentColor",
    width: size,
    height: size
  }, props), glyphs[glyph]);
}
Icon.propTypes = {
  is: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].elementType]),
  glyph: _propTypes["default"].oneOf(glyphNames),
  size: _propTypes["default"].number
};
var _default = exports["default"] = Icon;


//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/icons/dist/index.js
// module id = 186
// module chunks = 35783957827783